import { Accordion } from '../../../UseCases/subcomponents/Accordion'
import { SmarterQrCodesSection } from '../../../../../../../components/SmarterQrCodesSection/SmarterQrCodesSection'
import { FAQs } from '@dtx-company/app/shared/common/src/components/FAQs/FAQs'
import { FAQsSlice } from '@dtx-company/app/shared/common/src/components/FAQs/types'
import { FC, ReactNode, memo, useMemo } from 'react'
import {
  FooterAttachmentData,
  HomepageBelowFoldExperimentData,
  LargeProductSuitCardsData,
  TestimonialsCarouselData,
  UsedBySectionData,
  WaysToUseCarouselData
} from './types'
import { PrismicAccordionSlice } from '@dtx-company/true-common/src/types/PrismicAccordionSlice'
import { Stack } from '@dtx-company/design-system/src'
import { HomePageBelowFoldData as data } from '../HomepageBelowFoldData'
import FooterAttachmentSection from './subcomponents/FooterAttachmentSection'
import LargeProductSuitCardsSection from './subcomponents/LargeProductSuitCardsSection'
import TestimonialsCarousel from './subcomponents/TestimonialsCarousel'
import UsedBySection from './subcomponents/UsedBySection'
import WaysToUseCarouselSection from './subcomponents/WaysToUseCarouselSection'

const convertHomepageBelowFoldDataToSection = (
  data: HomepageBelowFoldExperimentData
): ReactNode[] =>
  data.map((slice, i) => {
    switch (slice.slice_type) {
      case 'large_product_card':
        return (
          <LargeProductSuitCardsSection
            data={slice as LargeProductSuitCardsData}
            key={`${slice.slice_type}_${i}`}
            sectionId={slice.slice_type}
          />
        )
      case 'testimonials_carousel':
        return (
          <TestimonialsCarousel
            data={slice as TestimonialsCarouselData}
            key={`${slice.slice_type}_${i}`}
            sectionId={slice.slice_type}
          />
        )
      case 'faqs':
        return (
          <FAQs
            id={(slice as FAQsSlice).id}
            slice_type={slice.slice_type}
            primary={(slice as FAQsSlice).primary}
            items={(slice as FAQsSlice).items}
            key={`${slice.slice_type}_${i}`}
          />
        )
      case 'footer_attachement':
        return (
          <FooterAttachmentSection
            data={slice as FooterAttachmentData}
            key={`${slice.slice_type}_${i}`}
            sectionId={slice.slice_type}
          />
        )
      case 'ways-to-use_carousel_1':
        return (
          <WaysToUseCarouselSection
            data={slice as WaysToUseCarouselData}
            key={`${slice.slice_type}_${i}`}
            sectionId={slice.slice_type}
          />
        )
      case 'contact_sales_page_used_by_footer':
        return (
          <UsedBySection
            data={slice as UsedBySectionData}
            key={`${slice.slice_type}_${i}`}
            dark={true}
            sectionId={slice.slice_type}
          />
        )
      case 'accordion':
        return (
          <Accordion
            key={`${slice.slice_type}_${i}`}
            primary={(slice as PrismicAccordionSlice).primary}
            items={(slice as PrismicAccordionSlice).items}
            slice_type={slice.slice_type}
          />
        )
      default:
        return null
    }
  })

export const LongAndColorful: FC = () => {
  data.splice(data.length - 1, 0, { slice_type: 'faq' })

  const sections: ReactNode[] = useMemo(() => {
    return convertHomepageBelowFoldDataToSection(data)
  }, [])

  return (
    <Stack direction="column" alignItems="center">
      <SmarterQrCodesSection />
      {sections}
    </Stack>
  )
}

export default memo(LongAndColorful)
